/* SiteExplorerEntityLmrbComponent.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const Registrations = require("../../../RegistrationNamespaces");
const Steve = require("@gluenetworks/steve_core").getInstance();
const _ = require("lodash");

class SiteExplorerEntityLmrbComponent extends GameEditor {
    constructor(
        logger,
        di,
        editorLayout,
        userSession,
        LicenseRestriction,
        storageFactory,
        solutionManager,
        SiteEntity,
        DataSyncConfig
    ) {
        super(logger, di);

        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._activeOrgId = userSession.activeOrganization.id;
        this._licenseRestriction = LicenseRestriction;
        this._solutionManager = solutionManager;
        this._isOSMSolutionAvailable = undefined;
        this._isCatalogEnable = undefined;
        this._sitePaths = undefined;
        this._storageFactory = storageFactory;
        this._openEditorFromUrl = false;
        this._filterFromUrl = false;
        this._siteEntityDef = SiteEntity;
        this._vendorMap = undefined;
        this._typeBaseMap = undefined;
        this._dataSyncConfig = DataSyncConfig;
        this._dataSyncConfigEntity = {};
        this._updateNameSpaces();

        this._registerDeviceExplorerListeners();

        const superRender = this.renderer.render;
        this.renderer.render = (args) => {
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer._rootElem.classList.add("site-explorer-entity-lmrb");
                if (this.currentSolutionName === "data_explorer") {
                    this.renderer._rootElem.classList.add("data-explorer-lmrb");
                }
                return this.whenGameEditorStorageIsReady().then(() => {
                    const otherParams = _.get(Steve.router.getRouteDetails(), "rd", {});
                    if (otherParams.openEditor || !_.isEmpty(otherParams.selection)) {
                        this._openEditorFromUrl = {
                            open: otherParams.openEditor || false,
                            selectedIds: otherParams.selection,
                        };
                    }
                    if (!_.isEmpty(otherParams.filter) || !_.isUndefined(otherParams.filter)) {
                        this._filterFromUrl = true;
                    }

                    if (this._LMRBLayout.state.bottom.dockletClicked === true) {
                        this._gameEditorData.setData(
                            this._LMRBLayout.state.bottom._state.openedPartId,
                            "currentExplorerView"
                        );
                        this._LMRBLayout.state.bottom.dockletClicked = undefined;
                    }

                    const currentView = this._whereToRedirect();
                    this._switchSolution(currentView);

                    return;
                });
            });
        };
    }

    _whereToRedirect() {
        let currentView = "";
        if (_.get(Steve.router.getRouteDetails(), "exp", false)) {
            let currentViewName = _.get(Steve.router.getRouteDetails(), "exp", "");
            if (this.currentSolutionName === "device_manager") {
                switch (currentViewName) {
                    case "device":
                        currentView = Registrations.DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                    case "site":
                        currentView = Registrations.SITE_EXPLORER_ENTITY_LMRB;
                        break;
                    case "network_discovery":
                        currentView = Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB;
                        break;
                    case "iot_device":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
                                : Registrations.DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                }
            }
        }

        return currentView;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _updateNameSpaces(withUpdate) {
        let solutionDefinition = this._solutionManager.getActiveSolution();
        let gameEditorViews = _.get(solutionDefinition, "siteExplorer.viewNamespaces", []);
        let gameEditorActions = _.get(solutionDefinition, "siteExplorer.actionNamespaces", []);

        if (this._userSession.authorizedActions.indexOf("manageSites") < 0) {
            gameEditorActions = gameEditorActions.filter(
                (ns) => ns !== Registrations.SITE_EXPLORER_ACTION_AUTO_ASSIGNMENT
            );
        }

        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), !withUpdate);
    }

    _updateActions(addList = [], removeList = []) {
        let _actions = [].concat(this._registeredActions, addList);
        _actions = _actions.filter((action) => {
            if (removeList.indexOf(action.fullyQualifiedName) >= 0) {
                return false;
            }
            return true;
        });
        this.registerActions(_actions);
    }

    _registerDeviceExplorerListeners() {
        this._unregisterDeviceExplorerListeners();
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );
        this._editorLayout.on(
            "EditorClosed",
            (this._onEditorClosed = this._onEditorClosed.bind(this))
        );
        this._editorLayout.on("ActiveTabChanged", this._onActiveTabChanged.bind(this));

        Steve.router.on(
            "RouteDetailsChanged",
            (this._onRouteInfoChanged = _.throttle(this._onRouteInfoChanged.bind(this), 500))
        );

        this._cabinetCmpnt.on(
            "ExplorerChanged",
            (this._onExplorerChanged = this._onExplorerChanged.bind(this))
        );
    }

    _unregisterDeviceExplorerListeners() {
        if (this._solutionManager) {
            this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        }
        if (this._userSession) {
            this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
        }
        // make sure this code fires before editorTab close triggers
        if (this._editorLayout) {
            this._editorLayout.removeListener("EditorClosed", this._onEditorClosed);
            this._editorLayout.removeListener("ActiveTabChanged", this._onActiveTabChanged);
        }
        if (Steve.router) {
            Steve.router.removeListener("RouteDetailsChanged", this._onRouteInfoChanged);
        }
        if (this._cabinetCmpnt) {
            this._cabinetCmpnt.removeListener("ExplorerChanged", this._onExplorerChanged);
        }
    }

    launchDeviceEditor(editorState, launchOpts) {
        const siteIds = _.concat(launchOpts.ids || [], launchOpts.id || []);
        const stringToHash = siteIds.join("_");
        launchOpts = _.omit(launchOpts, ["id", "ids"]);

        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    siteIds,
                });

                return this._editorLayout
                    .launchEditor(editorState, Registrations.SITE_INSTANCE_EDITOR, launchOpts)
                    .then(() => {
                        this.emit("EditorLaunched", editorState, launchOpts);
                        return Promise.resolve();
                    });
            });
    }

    launchDeviceMultiEditor(ids = []) {
        const editorState = {
            fqn: Registrations.DIE_VIEW_MULTIEDIT,
        };
        const launchOpts = {
            ids: ids,
        };

        return this.launchDeviceEditor(editorState, launchOpts);
    }

    launchSiteMultiEditor(ids = []) {
        const editorState = {
            fqn: Registrations.SIE_VIEW_MULTIEDIT,
        };
        const launchOpts = {
            ids: ids,
        };

        return this.launchDeviceEditor(editorState, launchOpts);
    }

    updateFilter(filterString) {
        if (_.isEmpty(filterString)) {
            this._reestablishFeed();
        } else {
            this._reestablishFeed(filterString);
        }
    }

    generateHash(stringToHash) {
        const encoder = new TextEncoder();
        const data = encoder.encode(stringToHash);

        return window.crypto.subtle.digest("SHA-256", data).then(hexString);

        function hexString(buffer) {
            const byteArray = new Uint8Array(buffer);
            const hexCodes = [...byteArray].map((value) => {
                const hexCode = Number(value).toString(16);
                return hexCode.padStart(2, "0");
            });
            return hexCodes.join("");
        }
    }

    onGridColumnUpdated() {
        this.runQuickConfirmationActionWorkflow(
            {
                message: "Column definitions have been changed. Do you want to refresh the page?",
                title: "Update Confirmation Check",
                confirmDetails: {
                    text: "Yes",
                    type: "text",
                },
            },
            (this.onGridUpdateAction = this.onGridUpdateAction.bind(this))
        );
    }

    onGridUpdateAction() {
        return this.renderer.render();
    }

    whenInitialized() {
        return Promise.resolve()
            .then(() => this._licenseRestriction.whenLicenseFeedIsReady())
            .then(() => this._loadAllSites())
            .then(() => {
                if (!Steve.controlAppNav.xDomeEnabled) {
                    this.hideBarView(Registrations.SITE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER);
                    this._LMRBLayout.state.bottom.removePart(
                        Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
                    );
                }
                return Promise.resolve();
            });
    }

    /**
     * On a first visit, reopen previously opened solution
     */
    _switchSolution(view = "") {
        if (
            this.currentSolutionName === "config_drift" ||
            this.currentSolutionName === "os_manager" ||
            this.currentSolutionName === "data_explorer" ||
            this.currentSolutionName === "device_manager"
        ) {
            let currentExplorerView = this._gameEditorData.getData("currentExplorerView");
            if (!_.isEmpty(view)) {
                currentExplorerView = view;
            }
            this._gameEditorData.setData(currentExplorerView, "currentExplorerViewTemp");
            if (
                currentExplorerView &&
                currentExplorerView === Registrations.AUDIT_POLICY_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.AUDIT_POLICY_EXPLORER_LMRB);
                /*} else if (currentExplorerView && currentExplorerView === Registrations.OS_CATALOG_EXPLORER_LMRB && this._isCatalogEnable) {
                this.openLMRBExplorer(Registrations.OS_CATALOG_EXPLORER_LMRB);*/
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.DATA_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.DATA_EXPLORER_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB);
            } else {
                this._cabinetCmpnt.selectView(Registrations.SITE_EXPLORER_VIEW_GRID);
            }
            return;
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    shutdown() {
        this._unregisterDeviceExplorerListeners();
        let shutdowns = [
            //_.invoke(this._statusBar, "shutdown")
        ];
        return Promise.all(shutdowns).then(
            () => {
                this._userSession = undefined;
                this._editorLayout = undefined;
                this._OsUpgradePlanPrefsEntity = undefined;
                this._licenseRestriction = undefined;
                this._isCatalogEnable = undefined;
                this._filterFromUrl = undefined;
                this._vendorMap = undefined;
                this._typeBaseMap = undefined;
                this._sitePaths = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn({error: err}, "SiteExplorerEntityLmrbComponent.shutdown() error");
            }
        );
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/
    _onSolutionChanged(/*newActiveSolution*/) {
        // Case 22070 -- removing the condition and shutting down always
        // if (
        //     newActiveSolution.lmrbNamespaces &&
        //     newActiveSolution.lmrbNamespaces.includes(Registrations.DEVICE_EXPLORER_ENTITY_LMRB)
        // ) {
        //     this._updateNameSpaces(true);
        //     this.renderer.render();
        // } else {
        this.shutdown();
        // }
    }

    _onOrganizationChange(newOrg, oldOrg) {
        this._unregisterDeviceExplorerListeners();
        if (!_.isUndefined(newOrg) && !_.isUndefined(oldOrg) && newOrg.id !== oldOrg.id) {
            this._updateNameSpaces(true);
            this.renderer.render().then(() => {
                this._registerDeviceExplorerListeners();
            });
        }
    }

    _onEditorClosed(tabId, editorParams) {
        this.emit("EditorClosed", tabId, editorParams);
    }

    _onActiveTabChanged(tabId, editorParams) {
        this.emit("ActiveTabChanged", tabId, editorParams);
    }

    _onRouteInfoChanged() {
        if (event && event.oldURL !== event.newURL) {
            const currentView = this._whereToRedirect();
            if (
                currentView &&
                this._gameEditorData.getData("currentExplorerViewTemp") !== currentView
            ) {
                this._gameEditorData.setData(currentView, "currentExplorerViewTemp");
                this._gameEditorData.setData(currentView, "currentExplorerView");
                this._cabinetCmpnt.emit("ExplorerChanged");
                this.openLMRBExplorer(currentView);
            }
        }
    }

    _onExplorerChanged() {
        this.shutdown();
    }

    async _loadAllSites() {
        const sitePaths = await this._siteEntityDef.loadSites(
            this._userSession.activeOrganization.id,
            {},
            {
                id: true,
                path: true,
                name: true,
            },
            {
                path: 1,
            }
        );
        // console.log("sitePaths", sitePaths);
        this._sitePaths = sitePaths;
        return Promise.resolve();
    }
}

module.exports = SiteExplorerEntityLmrbComponent;

SiteExplorerEntityLmrbComponent.$inject = [
    "$teve.logger",
    "$teve.di",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "$teve.licenseRestriction",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.entities.Site",
    "$teve.entities.DataSyncConfig",
];
SiteExplorerEntityLmrbComponent.$supportedQuadrants = ["bottom"];
SiteExplorerEntityLmrbComponent.$defaultQuadrants = ["bottom"];
SiteExplorerEntityLmrbComponent.$iconRepoName = "siteexplorer.site_explorer";
SiteExplorerEntityLmrbComponent.$displayName = "Site Explorer";
